/**
 * @fileoverview Date Input View - View for a date input
 */
goog.module('yext.ui.DateInputView');
goog.module.declareLegacyNamespace();

const googDate = goog.require('goog.date.Date');
const DateRange = goog.require('goog.date.DateRange');
const DateTimeFormat = goog.require('goog.i18n.DateTimeFormat');
const DateTimeParse = goog.require('goog.i18n.DateTimeParse');
const {DEPRECATED_DatePicker} = goog.require('yext.ui.components.deprecated.DEPRECATED_DatePicker');

const DATE_FORMAT = 'M/d/yyyy';
const ISO_FORMAT = 'yyyy-MM-dd';

const parser = new DateTimeParse(DATE_FORMAT);
const isoParser = new DateTimeParse(ISO_FORMAT);
const formatter = new DateTimeFormat(DATE_FORMAT);

function parseDate(s) {
  const date = new googDate();
  let n = isoParser.parse(s, date, {validate: true});
  if (n === 0) {
    // Didn't parse, try again but American
    n = parser.parse(s, date, {validate: true});
  }
  if (n === 0) {
    // Didn't parse either, return null
    return null;
  }
  return date;
}

function parseDateRange(min, max) {
  let start = DateRange.MINIMUM_DATE;
  if (typeof min === 'string') {
    start = parseDate(min);
  } else if (min) {
    start = min;
  }

  let end = DateRange.MAXIMUM_DATE;
  if (typeof max === 'string') {
    end = parseDate(max);
  } else if (max) {
    end = max;
  }

  return new DateRange(start, end);
}

class DateInputView {
  constructor(options = {}) {
    this.ariaLabel = options['ariaLabel'];
    this.callback_ = () => {};
    this.dateRange_ = parseDateRange(options['minDate'], options['maxDate']);
    this.date_ = null;
    this.el_ = document.createElement('span');
    this.el_.style.display = 'inline-block';

    this.set(options['defaultDate']);
  }

  init() {
    return this;
  }

  get() {
    if (this.date_) {
      return formatter.format(this.date_);
    } else {
      return '';
    }
  }

  getDate() {
    return this.date_;
  }

  mount($el) {
    $el.append(this.el_);
  }

  onChange(callback) {
    this.callback_ = callback;
  }

  set(date) {
    if (typeof date === 'string') {
      this.date_ = parseDate(date);
    } else {
      this.date_ = date;
    }
    if (this.date_) {
      this.applyDateRange_();
    }
    this.render_();
    this.callback_(this.get());
  }

  applyDateRange_() {
    const startDate = this.dateRange_.getStartDate();
    const endDate = this.dateRange_.getEndDate();
    if (this.date_ < startDate) {
      this.date_ = new googDate(startDate);
    } else if (this.date_ > endDate) {
      this.date_ = new googDate(endDate);
    }
  }

  render_() {
    ReactDOM.render(
      <DEPRECATED_DatePicker
        ariaLabel={this.ariaLabel}
        date={this.date_}
        min={this.dateRange_.getStartDate()}
        max={this.dateRange_.getEndDate()}
        onChange={newDate => {
          if (newDate) {
            this.date_ = parseDate(newDate);
          } else {
            this.date_ = null;
          }
          this.render_();
          this.callback_(this.get());
        }}
        width="110px"
      />,
      this.el_,
    );
  }
}

exports = DateInputView;
